var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-outer" }, [
    _c("div", { staticClass: "login-inner" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("changepwd.TITLE")))]),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("label", { attrs: { for: "name" } }, [
            _vm._v(_vm._s(_vm.$t("changepwd.FIELD_OLD_PWD"))),
          ]),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.old_pwd,
                  expression: "formData.old_pwd",
                },
              ],
              staticClass: "loginField",
              attrs: {
                id: "old_pwd",
                type: "password",
                required: "",
                autofocus: "",
                autocomplete: "",
                autoCorrect: "off",
                autoCapitalize: "none",
              },
              domProps: { value: _vm.formData.old_pwd },
              on: {
                change: _vm.validate,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formData, "old_pwd", $event.target.value)
                },
              },
            }),
          ]),
          _c("div", [
            _c("label", { attrs: { for: "password" } }, [
              _vm._v(_vm._s(_vm.$t("changepwd.FIELD_NEW_PWD"))),
            ]),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.new_pwd,
                    expression: "formData.new_pwd",
                  },
                ],
                staticClass: "loginField",
                attrs: {
                  id: "new_pwd",
                  type: "password",
                  required: "",
                  autocomplete: "",
                  autoCorrect: "off",
                  autoCapitalize: "none",
                },
                domProps: { value: _vm.formData.new_pwd },
                on: {
                  change: _vm.validate,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, "new_pwd", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _c("div", [
            _c("label", { attrs: { for: "password" } }, [
              _vm._v(_vm._s(_vm.$t("changepwd.FIELD_REPEAT_PWD"))),
            ]),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.rpt_pwd,
                    expression: "formData.rpt_pwd",
                  },
                ],
                staticClass: "loginField",
                attrs: {
                  id: "rpt_pwd",
                  type: "password",
                  required: "",
                  autocomplete: "",
                  autoCorrect: "off",
                  autoCapitalize: "none",
                },
                domProps: { value: _vm.formData.rpt_pwd },
                on: {
                  change: _vm.validate,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, "rpt_pwd", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _c("div", [
            _c("p"),
            _c("p", [
              _c("button", { attrs: { type: "submit" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("changepwd.BUTTON_CHANGE")) +
                    "\n          "
                ),
              ]),
              _vm._v("\n           \n          "),
              _c("button", { on: { click: _vm.goback } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("changepwd.BUTTON_DISMISS")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _c("div", [
            _vm.errors.length
              ? _c("p", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("changepwd.CHANGE_ERRORS_TEXT"))),
                  ]),
                ])
              : _vm._e(),
            _c(
              "ul",
              { staticClass: "errors" },
              _vm._l(_vm.errors, function (error) {
                return _c("li", { key: error }, [
                  _vm._v("\n            " + _vm._s(error) + "\n          "),
                ])
              }),
              0
            ),
          ]),
          _vm.errorMsg
            ? _c("div", [
                _vm._v("\n        " + _vm._s(_vm.errorMsg) + "\n      "),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }